<form [formGroup]="formGroup" class="grid grid-cols-2 gap-2">
    <div class="my-2">
        <mat-label>Purpose of SSSV Function Test</mat-label>
        <mat-form-field class="custom-mat-form-field w-full">
            <input matInput class="input" formControlName="purposeFunctTest" />
        </mat-form-field>
    </div>
    <div class="my-2">
        <mat-label>Type of Downhole Barrier Tested</mat-label>
        <mat-form-field class="custom-mat-form-field w-full">
            <mat-select matNativeControl formControlName="typeOfDownholeBarrier">
                <mat-option [value]="'tr-scssv'">TR-SCSSV</mat-option>
                <mat-option [value]="'wr-scssv'">WR-SCSSV</mat-option>
                <mat-option [value]="'trscssv'">TRSCSSV</mat-option>
                <mat-option [value]="'retrieable valve/plug'">Retrievable Valve / Plug</mat-option>
                <mat-option [value]="'storm choke'">STORM CHOKE</mat-option>
                <mat-option [value]="'downhole plug'">DOWNHOLE PLUG</mat-option>
            </mat-select>
        </mat-form-field>
    </div>
    <div class="my-2 col-span-2">
        <mat-label>Pressure bleed off to</mat-label>
        <div class="grid grid-cols-2 gap-2">
            <mat-form-field class="custom-mat-form-field w-full">
                <mat-select matNativeControl formControlName="pressureBleedOff">
                    <mat-option [value]="'PRODUCTION HEADER'">PRODUCTION HEADER</mat-option>
                    <mat-option value="TEST HEADER">TEST HEADER</mat-option>
                    <mat-option value="CLOSED DRAIN">CLOSED DRAIN</mat-option>
                </mat-select>

                <!-- <input
                    type="text"
                    aria-label="Number"
                    matInput
                    [matAutocomplete]="pressureBleed"
                    formControlName="pressureBleedOff"
                />
                <mat-autocomplete
                    autoActiveFirstOption
                    #pressureBleed="matAutocomplete"
                >
                    <mat-option [value]="'PRODUCTION HEADER'">PRODUCTION HEADER</mat-option>
                    <mat-option value="TEST HEADER">TEST HEADER</mat-option>
                    <mat-option value="CLOSED DRAIN">CLOSED DRAIN</mat-option>
                </mat-autocomplete> -->
            </mat-form-field>

            <mat-form-field class="custom-mat-form-field w-full">
                <input type="number" aria-label="Number" matInput formControlName="pressureBleedOffPsi" />
                <span matTextSuffix>psi</span>
            </mat-form-field>
        </div>
    </div>
    <mat-label>
        Shut-in the wing valve. Bleed off THP to the lowest possible, preferably
        not to 0 psi.
    </mat-label>
    <div class="grid grid-cols-2 gap-2">
        <div class="my-2">
            <mat-label>Record new THP</mat-label>
            <mat-form-field class="custom-mat-form-field w-full">
                <input type="number" aria-label="Number" matInput formControlName="thp" />
                <span matTextSuffix>psi</span>
            </mat-form-field>
        </div>
    </div>
</form>
<hr />
<form [formGroup]="formGroup" class="grid grid-cols-2 gap-2">
    <!-- <ng-container *ngIf="isSSSV"> -->
    <div class="my-2">
        <mat-label>SSSV Self Equalizing</mat-label>
        <div class="grid grid-cols-2 md:grid-cols-3">
            <mat-radio-group class="grid grid-cols-2 col-span-2 radio-en" formControlName="isSssvSelfEqualizing">
                <mat-radio-button class="col-span-1" [value]="true">
                    Yes
                </mat-radio-button>
                <mat-radio-button class="col-span-1" [value]="false">
                    No
                </mat-radio-button>
            </mat-radio-group>
        </div>
    </div>
    <div class="my-2">
        <mat-label>SSSV Equipment Brand / OEM</mat-label>
        <mat-form-field class="custom-mat-form-field w-full">
            <input type="text" aria-label="Number" matInput formControlName="ssvOem" />
        </mat-form-field>
    </div>
    <div class="my-2">
        <mat-label>SSSV Size</mat-label>
        <mat-form-field class="custom-mat-form-field w-full">
            <input type="text" aria-label="Number" matInput formControlName="ssvSize" />
        </mat-form-field>
    </div>
    <div class="my-2">
        <mat-label>Cycling Test</mat-label>
        <mat-form-field class="custom-mat-form-field w-full">
            <input type="number" aria-label="Number" matInput formControlName="cyclingTest" min="0" pattern="[0-9]*" />
            <span matTextSuffix>cycle(s)</span>
        </mat-form-field>
    </div>
    <div class="my-2">
        <mat-label>CL Pressure</mat-label>
        <mat-form-field class="custom-mat-form-field w-full">
            <input type="number" aria-label="Number" matInput formControlName="clPressure" />
            <span matTextSuffix>psi (during cycling test)</span>
        </mat-form-field>
    </div>
    <div class="my-2">
        <mat-label>Hydraulic Return</mat-label>
        <mat-form-field class="custom-mat-form-field w-full">
            <input type="number" aria-label="Number" matInput formControlName="hydReturn" />
            <span matTextSuffix>ml</span>
        </mat-form-field>
    </div>
    <div class="my-2">
        <mat-label>Slam Test</mat-label>
        <div class="grid grid-cols-2 md:grid-cols-3">
            <mat-radio-group class="grid grid-cols-2 col-span-2" formControlName="slamTest">
                <mat-radio-button class="col-span-1" [value]="true">
                    Yes
                </mat-radio-button>
                <mat-radio-button class="col-span-1" [value]="false">
                    No
                </mat-radio-button>
            </mat-radio-group>
        </div>
    </div>
    <div class="my-2">
        <mat-label>Blowing Gas</mat-label>
        <div class="grid grid-cols-2 md:grid-cols-3">
            <mat-radio-group class="grid grid-cols-2  col-span-2" formControlName="blowingGas">
                <mat-radio-button class="col-span-1" [value]="true">
                    Yes
                </mat-radio-button>
                <mat-radio-button class="col-span-1" [value]="false">
                    No
                </mat-radio-button>
            </mat-radio-group>
        </div>
    </div>
    <!-- </ng-container> -->

    <div class="my-2">
        <mat-label>Opening Indication</mat-label>
        <div class="grid grid-cols-2 md:grid-cols-3">
            <mat-radio-group class="grid grid-cols-2 col-span-2" formControlName="openingIndication">
                <mat-radio-button class="col-span-1" [value]="true">
                    Yes
                </mat-radio-button>
                <mat-radio-button class="col-span-1" [value]="false">
                    No
                </mat-radio-button>
            </mat-radio-group>
            <mat-form-field class="col-span-1 custom-mat-form-field w-full">
                <input type="text" aria-label="Number" matInput formControlName="openingIndicationPsi" />
                <span matTextSuffix>psi</span>
            </mat-form-field>
        </div>
    </div>
    <div class="my-2">
        <mat-label>Closing Indication</mat-label>
        <div class="grid grid-cols-2 md:grid-cols-3">
            <mat-radio-group class="grid grid-cols-2 col-span-2" formControlName="closingIndication">
                <mat-radio-button class="col-span-1" [value]="true">
                    Yes
                </mat-radio-button>
                <mat-radio-button class="col-span-1" [value]="false">
                    No
                </mat-radio-button>
            </mat-radio-group>
            <mat-form-field class="col-span-1 custom-mat-form-field w-full">
                <input type="text" aria-label="Number" matInput formControlName="closingIndicationPsi" />
                <span matTextSuffix>psi</span>
            </mat-form-field>
        </div>
    </div>

    <hr class="col-span-2" />

    <!-- <ng-container *ngIf="!isSSSV"> -->
    <mat-label class="col-span-2 text-lg">Retrievable Valve / Plug</mat-label>

    <div class="my-2">
        <mat-label>Type</mat-label>
        <mat-form-field class="custom-mat-form-field w-full">
            <mat-select matNativeControl formControlName="wrsvType">
                <mat-option *ngFor="let type of wrsvTypes | async" [value]="type.name">
                    {{ type.name }}
                </mat-option>
            </mat-select>
        </mat-form-field>
    </div>
    <div class="my-2">
        <mat-label>Equipment Brand / OEM</mat-label>
        <mat-form-field class="custom-mat-form-field w-full">
            <input type="text" aria-label="Number" matInput formControlName="wrsvOem" />
        </mat-form-field>
    </div>
    <div class="my-2">
        <mat-label>Size</mat-label>
        <mat-form-field class="custom-mat-form-field w-full">
            <input type="text" aria-label="Number" matInput formControlName="wrsvSize" />
        </mat-form-field>
    </div>
    <div class="my-2">
        <mat-label>Installed Depth</mat-label>
        <mat-form-field class="custom-mat-form-field w-full">
            <input type="text" aria-label="Number" matInput formControlName="installationDepth" />
            <span matTextSuffix>meter</span>
        </mat-form-field>
    </div>
    <div class="my-2">
        <mat-label>Location</mat-label>
        <mat-form-field class="custom-mat-form-field w-full">
            <input type="text" aria-label="Number" matInput formControlName="installationAt" />
        </mat-form-field>
    </div>
    <!-- </ng-container> -->
</form>
<hr />

<table class="SssvTable">
    <tr class="bg-Grey">
        <th>TIME AFTER SHUT IN</th>
        <th>TUBING PRESSURE (psi)</th>
        <th>PCP - A annulus (psi)</th>
        <th>PCL (psi)</th>
        <th>SCL (psi)</th>
        <th>VOID AREA (psi)</th>
    </tr>
    <ng-container *ngFor="
            let tubingPressure of cdftTimeTubingPressure.controls;
            let i = index
        ">
        <tr>
            <td class="w-40">
                {{ tubingPressure.get("timeAfterShutIn").value + " MIN" }}
            </td>
            <td class="w-40">
                <input type="number" class="text-center w-full" inputmode="decimal" autocomplete="off"
                    enterkeyhint="next" step="0.1" min="0" [formControl]="tubingPressure.get('tubingPressure')"
                    numericCellNav [rowIndex]="i" colKey="tubingPressure" [attr.data-row]="i"
                    data-col="tubingPressure" />
            </td>
            <td>
                <input type="number" class="text-center w-full" inputmode="decimal" autocomplete="off"
                    enterkeyhint="next" step="0.1" min="0" [formControl]="tubingPressure.get('pcpAnnulus')"
                    numericCellNav [rowIndex]="i" colKey="pcpAnnulus" [attr.data-row]="i" data-col="pcpAnnulus" />
            </td>
            <td>
                <input type="number" class="text-center w-full" inputmode="decimal" autocomplete="off"
                    enterkeyhint="next" step="0.1" min="0" [formControl]="tubingPressure.get('pclPsi')" numericCellNav
                    [rowIndex]="i" colKey="pclPsi" [attr.data-row]="i" data-col="pclPsi" />
            </td>
            <td>
                <input type="number" class="text-center w-full" inputmode="decimal" autocomplete="off"
                    enterkeyhint="next" step="0.1" min="0" [formControl]="tubingPressure.get('sclPsi')" numericCellNav
                    [rowIndex]="i" colKey="sclPsi" [attr.data-row]="i" data-col="sclPsi" />
            </td>
            <td>
                <input type="number" class="text-center w-full" inputmode="decimal" autocomplete="off"
                    enterkeyhint="next" step="0.1" min="0" [formControl]="tubingPressure.get('voidAreaPsi')"
                    numericCellNav [rowIndex]="i" colKey="voidAreaPsi" [attr.data-row]="i" data-col="voidAreaPsi" />
            </td>
        </tr>
    </ng-container>
</table>
<form [formGroup]="formGroup" class="w-full min-w-0" style="overflow-y: auto">
    <div class="grid grid-cols-2 gap-2">
        <div class="my-2">
            <mat-label>SSSV / Downhole Valve Leak Rate</mat-label>
            <mat-form-field class="custom-mat-form-field w-full">
                <input type="text" aria-label="Number" matInput formControlName="valveLeakRate" />
                <span matTextSuffix>psi/30mins</span>
            </mat-form-field>
        </div>
    </div>
</form>

<div>
    <span>
        Equalize the pressure across SSSV. Open SSSV by applying recommended
        hold open pressure on control line. Monitor control line pressure for 30
        mins. </span><br />
    <span> Remarks: Fill up data in the Control Line Test Report Section </span>
</div>

<form [formGroup]="formGroup" class="grid grid-cols-2 gap-2">
    <div class="my-2">
        <mat-label>Final Well Status</mat-label>
        <mat-form-field class="custom-mat-form-field w-full">
            <mat-select matNativeControl formControlName="finalWellStatus">
                <mat-option value="SHUT IN">SHUT IN</mat-option>
                <mat-option value="IDLE">IDLE</mat-option>
                <mat-option value="PRODUCING">PRODUCING</mat-option>
                <mat-option value="INJECTING">INJECTING</mat-option>
            </mat-select>

            <!-- <input
                type="text"
                aria-label="Number"
                matInput
                [matAutocomplete]="finalWellStatus"
                formControlName="finalWellStatus"
            />
            <mat-autocomplete
                autoActiveFirstOption
                #finalWellStatus="matAutocomplete"
            >
                <mat-option value="SHUT IN">SHUT IN</mat-option>
                <mat-option value="IDLE">IDLE</mat-option>
                <mat-option value="PRODUCING">PRODUCING</mat-option>
                <mat-option value="INJECTING">INJECTING</mat-option>
            </mat-autocomplete> -->
        </mat-form-field>
    </div>
</form>

<table class="LeakRateTable">
    <tr class="bg-Grey">
        <td class="w-48">Allowable Leak Rate</td>
        <td>4-1/2</td>
        <td>3-1/2</td>
        <td>2-7/8</td>
        <td>2-3/8</td>
        <td>Time</td>
    </tr>
    <tr>
        <td>Well Type</td>
        <td>PSI</td>
        <td>PSI</td>
        <td>PSI</td>
        <td>PSI</td>
        <td rowspan="3">
            {{ leakRateTable.time }}
        </td>
    </tr>
    <tr>
        <td>Oil Producer/ Water Injector</td>
        <td>{{ leakRateTable.water.leak_rate_412 }}</td>
        <td>{{ leakRateTable.water.leak_rate_312 }}</td>
        <td>{{ leakRateTable.water.leak_rate_278 }}</td>
        <td>{{ leakRateTable.water.leak_rate_238 }}</td>
    </tr>
    <tr>
        <td>Gas Producer/ Gas Injector</td>
        <td>{{ leakRateTable.gas.leak_rate_412 }}</td>
        <td>{{ leakRateTable.gas.leak_rate_312 }}</td>
        <td>{{ leakRateTable.gas.leak_rate_278 }}</td>
        <td>{{ leakRateTable.gas.leak_rate_238 }}</td>
    </tr>
</table>

<form [formGroup]="formGroup" class="grid grid-cols-2 gap-2">
    <div class="my-2">
        <mat-label>SSSV Result</mat-label>
        <mat-form-field class="custom-mat-form-field w-full">
            <input type="text" aria-label="Number" matInput [matAutocomplete]="sssvResult" formControlName="sssvResult"
                class=" p-2 rounded text-center font-semibold" [ngClass]="{
                    'bg-good' : formGroup.get('sssvResult')?.value == 'GOOD',
                    'bg-degraded' : formGroup.get('sssvResult')?.value == 'DEGRADED',
                    'bg-failed' : formGroup.get('sssvResult')?.value == 'FAILED',
                }" readonly />
            <mat-autocomplete autoActiveFirstOption #sssvResult="matAutocomplete">
                <mat-option value="GOOD" class="bg-good">GOOD</mat-option>
                <mat-option value="DEGRADED" class="bg-degraded">DEGRADED</mat-option>
                <mat-option value="FAILED" class="bg-failed">FAILED</mat-option>
                <mat-option value="UTT">UTT</mat-option>
            </mat-autocomplete>
        </mat-form-field>
    </div>
</form>